"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _reportUtil = require("../../utils/reportUtil");
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (Object.keys(data).length > 1) {
    const _ref = data,
      backgroundColor = _ref.backgroundColor,
      cardList = _ref.cardList,
      themeType = _ref.themeType,
      modTitle = _ref.modTitle,
      desc = _ref.desc,
      mergeComponentStatus = _ref.mergeComponentStatus,
      flexSmallTitle = _ref.flexSmallTitle,
      paddingBottomNum = _ref.paddingBottomNum,
      paddingTopNum = _ref.paddingTopNum,
      fontColor = _ref.fontColor;
    const bgStyle = backgroundColor ? (0, _componentUtils.doComponentsBgColorEvent)(backgroundColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_NumberCard', componentKey, modTitle || ''])), /*#__PURE__*/React.createElement(_intlDesignUi.NumberCard, {
      flexTitle: modTitle,
      themeType: themeType,
      desc: desc,
      fontColor: fontColor,
      mergeComponentStatus: mergeComponentStatus,
      flexSmallTitle: flexSmallTitle,
      paddingBottomNum: paddingBottomNum,
      paddingTopNum: paddingTopNum,
      cardList: cardList,
      style: backgroundColor ? bgStyle : {}
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}